import VueRouter from 'vue-router'

import Login from './pages/Auth/Login.vue'
import SignUpIndie from './pages/Auth/SignUpIndie.vue'

import Landing from './pages/Landing.vue'
import JoinUs from './pages/JoinUs.vue'
import ServiceDetails from './pages/Customer/ServiceDetails.vue'
import ServiceCost from './pages/Customer/ServiceCost.vue'
import ServiceForm from './pages/Customer/ServiceForm.vue'

import WorkerHome from './pages/Worker/Home.vue'
import EditProfile from './pages/Worker/EditProfile.vue'
import CreateService from './pages/Worker/CreateService.vue'
import WorkerBlank from './pages/Worker/Blank.vue'

import NotFound from './pages/NotFound.vue'

const isGuest = (to, from, next) => {
  if (localStorage.getItem('jwt_token') == null) {
    next()
    return
  }
  next('/'+localStorage.getItem('user_level'))
}

const isWorker = (to, from, next) => {
  if (localStorage.getItem('user_level') == 'worker') {
    next()
    return
  }
  next('/login')
}

/*
const isCustomer = (to, from, next) => {
  if (localStorage.getItem('user_level') == 'customer') {
    next()
    return
  }
  next('/login')
}
*/

export default new VueRouter({
  routes: [
    {
      path: '/',
      component: Landing
    },
    {
      path: '/login',
      component: Login,
      beforeEnter: isGuest
    },
    {
      path: '/signup/indie',
      component: SignUpIndie,
      beforeEnter: isGuest
    },
    {
      path: '/join_us',
      component: JoinUs,
      beforeEnter: isGuest
    },

    {
      path: '/service/:serviceId',
      component: ServiceDetails,
      beforeEnter: isGuest
    },
    {
      path: '/service/:serviceId/cost',
      component: ServiceCost,
      beforeEnter: isGuest
    },
    {
      path: '/service/:serviceId/form',
      component: ServiceForm,
      beforeEnter: isGuest
    },

    // Rutas del trabajador
    {
      path: '/worker',
      component: WorkerHome,
      beforeEnter: isWorker
    },
    {
      path: '/worker/blank',
      component: WorkerBlank,
      beforeEnter: isWorker
    },
    {
      path: '/worker/profile/edit',
      component: EditProfile,
      beforeEnter: isWorker
    },
    {
      path: '/worker/service/create',
      component: CreateService,
      beforeEnter: isWorker
    },
    {
      path: '*',
      component: NotFound,
    }
  ]
})